<template>
  <div class="contentBox">
    <navBox :id="navId"  ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content">
      <myHeader ref="myHeader"></myHeader>
      <div class="MobelBox" v-if="addType" style="height:calc( 100% - 100px )">
        <div class="write-txt">
          <p class="write-title">选择演讲类型<span>*</span></p>
          <div class="write-text">
            <el-select v-model="addObj.speech_type" placeholder="请选择" @change="speechChange">
              <el-option
                v-for="item in speechlist"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <span>请选择</span>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title">是否闭眼演讲（视频演讲）:<span>*</span></p>
          <div class="write-text">
            <el-radio-group v-model="addObj.is_close_eyes">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title">是否需要用户自行选择是否闭眼:<span>*</span></p>
          <div class="write-text" style="width:50%;">
            <el-radio-group v-model="addObj.is_user_close_eyes">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div v-if="addObj.speech_type==1" style="display:block;">
          <div class="write-txt">
            <p class="write-title">演讲主题<span>*</span></p>
            <div class="write-text">
              <textarea placeholder="" v-model="addObj.title"></textarea>
              <!-- <span>最多输入30个以内的中文</span> -->
            </div>
          </div>
          <div class="write-txt">
            <p class="write-title">每日一词<span>*</span></p>
            <div class="write-text">
              <textarea placeholder="" v-model="addObj.keyword"></textarea>
              <!-- <span>最多输入90个以内的中英文</span> -->
            </div>
          </div>

          <div class="write-txt">
            <p class="write-title">语言<span>*</span></p>
            <div class="write-text">
              <el-select v-model="addObj.language" placeholder="请选择">
                <el-option
                  v-for="item in typelist"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <span>请选择</span>
            </div>
          </div>

          <div class="write-txt">
            <p class="write-title">排序<span>*</span></p>
            <div class="write-text">
              <input type="number" v-model="addObj.sort">
            </div>
          </div>
        </div>

        <div v-else style="display:block;">
          <div class="write-txt">
            <p class="write-title">演讲主题<span>*</span></p>
            <div class="write-text">
              <textarea placeholder="" v-model="addObj.title"></textarea>
              <!-- <span>最多输入30个以内的中文</span> -->
            </div>
          </div>

          <div class="write-txt">
            <p class="write-title">演讲内容<span>*</span></p>
            <div class="write-text">
              <textarea placeholder="" v-model="addObj.content"></textarea>
              <!-- <span>最多输入30个以内的中文</span> -->
            </div>
          </div>

          <div class="write-txt"  v-loading="loadingImg" :element-loading-text="loadTxt">
            <p class="write-title">上传图片</p>
            <div class="write-text">
              <div style="display:inline-block;">
                <div class="img" @mouseenter="imgShow" @mouseleave="imgHide" v-for="(item,index) in addObj.images" :key="index" v-show="addObj.images.length>0" >
                  <img :src="'https://pic.speechcoach.cn/'+item" alt="">
                  <div class="hover" v-if="imgType" @click="imgRemove(index)">
                    <i class="icon-delete" ></i>
                  </div>
                </div>
              </div>
              <el-upload
                :action="'https://upload.qiniup.com'"
                :data="uploadObj"
                list-type="picture-card"
                :before-upload="beforeUploadImg"
                :on-success="(response, file, fileList)=>{return handleSuccessImg(response, file, fileList)}"
                :on-progress="handleProgressImg"
                :on-remove="handleRemoveVideo"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img
                  width="100%"
                  :src="'https://pic.bi-rong.com/' + addObj.image"
                  alt=""
                />
              </el-dialog>
            </div>
          </div>

          <div style="display:block;" v-loading="loading" :element-loading-text="loadTxt">
            <div style="display:block;" v-for="(item,index) in addObj.videos" :key="index">
              <div class="write-txt">
                <p class="write-title">上传视频{{(index+1)}}</p>
                <div class="write-text">
                  {{item.video}}
                  <div class="img" v-if="item.video">
                    <video :src="'https://pic.speechcoach.cn/'+item.video" alt=""></video>
                  </div>
                  <!-- <el-upload
                    :action="'https://upload.qiniup.com'"
                    :data="uploadObj"
                    :accept="'video/mp4,video/x-flv,video/quicktime'"
                    :before-upload="beforeUploadVideo"
                    :on-success="(response, file, fileList)=>{return handleSuccessVideo(response, file, fileList,index)}"
                    :on-progress="handleProgressImg"
                    :on-remove="handleRemoveVideo"
                    :show-file-list="true"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <el-dialog :visible.sync="dialogVisible">
                    <img
                      width="100%"
                      :src="'https://pic.bi-rong.com/' + item.video"
                      alt=""
                    />
                  </el-dialog> -->
                  <el-upload
                    class="upload-demo"
                    action="https://upload.qiniup.com" 
                    :accept="'video/mp4,video/x-flv,video/quicktime'"
                    :data="uploadObj"
                    :show-file-list="false"
                    :on-progress="handleProgressImg"
                    :on-success="(response, file, fileList)=>{return handleSuccessVideo(response, file, fileList,index)}"
                    :before-upload="beforeUploadVideo"
                    >
                    <el-button size="small" type="primary">点击上传</el-button>
                  </el-upload>
                  <button class="btn btn-video-add" @click="videoAdd">添加</button>
                  <button class="btn btn-video-remove" @click="videoRemove(index)" v-if="index>0">删除</button>
                </div>
                
              </div>

              <div class="write-txt">
                <p class="write-title">视频{{(index+1)}}文本</p>
                <div class="write-text">
                  <textarea placeholder="" v-model="item.video_cont"></textarea>
                  <!-- <span>最多输入30个以内的中文</span> -->
                </div>
              </div>
            </div>
          </div>
          <div class="write-txt">
            <p class="write-title">每日一词<span>*</span></p>
            <div class="write-text">
              <textarea placeholder="" v-model="addObj.keyword"></textarea>
              <!-- <span>最多输入90个以内的中英文</span> -->
            </div>
          </div>
          <div class="write-txt">
            <p class="write-title">排序<span>*</span></p>
            <div class="write-text">
              <input type="number" v-model="addObj.sort">
            </div>
          </div>
        </div>

        
        <div class="write-btnBox">
          <button class="btn btn-save" @click="saveSub">保存</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>
      <div class="MobelBox wordBox" v-else-if="wordType">
        <button class="btn btn-back" @click="closeSub">返回</button>
        <div v-for="(item,index) in wordObj.words" :key="index" class="word-item">
          <div class="write-txt">
            <p class="write-title">第{{(index+1)}}次</p>
            <div class="write-text">
              <button class="btn btn-word-remove" @click="wordRemove(index)" v-if="index>0">删除</button>
            </div>
          </div>
          <div class="write-txt">
            <p class="write-title">演讲主题<span>*</span></p>
            <div class="write-text">
              <textarea placeholder="" v-model="item.title"></textarea>
              <span>最多输入30个以内的中文</span>
            </div>
          </div>
          <div class="write-txt">
            <p class="write-title">每日一词<span>*</span></p>
            <div class="write-text">
              <textarea placeholder="" v-model="item.keyword"></textarea>
              <span>最多输入90个以内的中英文</span>
            </div>
          </div>

          <div class="write-txt">
            <p class="write-title">类型<span>*</span></p>
            <div class="write-text">
              <el-select v-model="item.language" placeholder="请选择">
                <el-option
                  v-for="item in typelist"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <span>请选择</span>
            </div>
          </div>

          <div class="write-txt">
            <p class="write-title">排序<span>*</span></p>
            <div class="write-text">
              <input type="number" v-model="item.sort">
            </div>
          </div>
        </div>
        <button class="btn-word-add" @click="wordAdd">继续添加</button>
        <div class="write-btnBox">
          <button class="btn btn-save" @click="wordSub">保存</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>
      <div class="organiza-txt" v-else>
        <div class="organiza-title clear">
          <div class="organiza-left" @click="addSub">
            <img src="~@/assets/images/icon-add.png" alt="">
            <p>添加词库</p>
          </div>
          <div class="organiza-left" @click="wordShow"> 
            <p>固定词库</p>
          </div>
          <div class="btnBox">
            <button class="btn btn-add" @click="updown">下载模板</button>
            <el-upload
              class="upload-demo btn btn-import"
              :action="url+'/admin/ClockIn/importLexicon'"
              :headers="{'userToken':token}"
              :on-success="handleSuccess"
              :before-upload="beforeUpload"
              accept=".xls, .xlsx"
              :show-file-list="false"
            >
              <el-button size="small" type="primary">导入即兴词库</el-button>
            </el-upload>
          </div>
        </div>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.id">{{item.id}}</p>
              <p :title="item.speech_type==1?'即兴演讲':'费曼练习'">{{item.speech_type==1?'即兴演讲':'费曼练习'}}</p>
              <p :title="item.title">{{item.title}}</p>
              <p :title="item.keyword">{{item.keyword}}</p>
              <p :title="item.content">{{item.content}}</p>
              <p :title="item.sort">{{item.sort}}</p>
              <p :title="item.add_time">{{item.add_time}}</p>
              <p>
                <button title="修改" class="btn btn-revise" @click="buildSub(item)"></button>
                <button title="删除" class="btn btn-remove" @click="removeShow(item)"></button>
              </p>
            </div>
          </div>
          
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>

      
    </div>

    <div class="msgBox" v-if="removeType">
      <div class="contv">
        <p class="title">是否确定删除？</p>
        <div class="btnBox">
          <button class="btn btn-close" @click="ModelHide('remove')">取消</button>
          <button class="btn btn-sub" @click="removeSub">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getLexiconList,saveLexicon,delLexicon,getLexiconDetail ,saveFixedLexicon,getFixedLexiconDetail ,getUploadToken} from "@/assets/js/api";
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
export default {
  name: "index",
  data() {
    return {
      navId:'9',
      titleList:[
        {id:1,title:'ID'},
        {id:2,title:'演讲类型'},
        {id:3,title:'演讲主题'},
        {id:4,title:'每日一词'},
        {id:5,title:'演讲内容'},
        {id:6,title:'排序'},
        {id:7,title:'添加时间'},
        {id:8,title:'操作'},
      ],
      speechlist:[
        {id:1,title:'即兴演讲'},
        {id:2,title:'费曼练习'},
      ],
      dataList:[
      ],
      addType:'',
      removeType:false,
      token:'',
      obj:{
        page:1,
        rows:10
      },
      addObj:{
        speech_type:1,
        title:'',
        keyword:'',
        language:1,
        sort:'',
        is_user_close_eyes:'0',
        is_close_eyes:'0',
      },
      totalPage:0,
      removeID:'',
      url:'',
      fileUrl:'/static/词库导入表.xlsx',
      typelist:[
        {id:1,title:'中文'},
        {id:2,title:'英文'},
      ],
      wordType:false,
      wordObj:{
        words:[
          {title:'',keyword:'',language:1}
        ]
      },
      uploadObj: {
        token: "",
        key: "",
      },
      uploadUrl: "",
      loading:false,
      loadTxt:'',
      dialogVisible:false,
      imgType:false,
      loadingImg:false
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    this.token = localStorage.getItem('token');
    this.url = this.$refs.navBox.url;
    this.getList();
    this.getToken();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    async getToken(){
      var that = this;
      try {
        const response = await getUploadToken(this.token);
        if(response.code == 200){
          that.uploadObj.token = response.data.token;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      };
      
    },

    async getList(){
      var that = this;
      try {
        const response = await getLexiconList(this.obj,this.token);
        if(response.code == 200){
          that.dataList = response.data.list;
          that.totalPage = response.data.total_page;        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    addSub(){
      var that = this;
      this.addType = 'add';
    },

    async buildSub(e){
      var that = this;
      try {
        const response = await getLexiconDetail({id:e.id},this.token);
        if(response.code == 200){
          that.addObj =  response.data;
          that.addType = 'edit';
          if(that.addObj.speech_type&&that.addObj.images == null){
            that.addObj.images = [];
          }
          that.addObj.is_close_eyes = JSON.stringify(that.addObj.is_close_eyes);
          that.addObj.is_user_close_eyes = JSON.stringify(that.addObj.is_user_close_eyes);
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
      
    },

    removeShow(e){
      this.removeID = e.id;
      this.removeType = true;
    },

    async removeSub(){
      var that = this;
      try {
        const response = await delLexicon({id:this.removeID},this.token);
        if(response.code == 200){
          that.$message('删除成功');
          that.getList();
          that.ModelHide('remove');       
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    ModelHide(type){
      var that = this;
      if(type == 'remove'){
        that.removeType = false;
        taht.removeID = '';
      }
    },

    async saveSub(){
      var that = this;
      if(this.addObj.title == ''){
        that.$message('请输入主题！');
        return false;
      }
      if(this.addObj.keyword == ''){
        that.$message('请输入每日一词！');
        return false;
      }
      try {
        const response = await saveLexicon(this.addObj,this.token);
        if(response.code == 200){
          that.$message('成功');
          that.closeSub();
          that.getList();        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    closeSub(){
      this.addType = '';
      this.addObj = {
        speech_type:1,
        title:'',
        keyword:'',
        language:1,
        sort:'',
        is_user_close_eyes:'0',
        is_close_eyes:'0',
      },
      this.wordType=false;
      this.wordObj={
        words:[
          {title:'',keyword:'',language:1}
        ]
      }
    },

    updown(){
      var that = this;
      try {
        var elemIF = document.createElement("iframe");
        elemIF.src = that.fileUrl;
        elemIF.style.display = "none";
        document.body.appendChild(elemIF);
      } catch (e) {
          that.$message('下载异常！')
      }
    },

    beforeUpload(){
      this.loading = true;
    }, 
    handleSuccess(response, file, fileList){
      var that = this;
      if(response.code == 200){
        that.$message('上传成功！');
        that.loading = false;
        that.getList();
      } else {
        that.$message(response.msg);
      }
    },

    async wordShow(){
      var that = this;
      try {
        const response = await getFixedLexiconDetail(this.token);
        if(response.code == 200){
          if(response.data.words.length > 0){
            that.wordObj = response.data;
          } else {
            that.wordObj = {
              words:[
                {title:'',keyword:'',language:1}
              ]
            }
          }
          that.wordType = true;   
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    wordRemove(index){
      this.wordObj.words.splice(index,1);
    },

    wordAdd(){
      this.wordObj.words.push({title:'',keyword:'',language:1});
    },

    async wordSub(){
      var that = this;
      console.log(this.wordObj.words)
      for (let i = 0; i < this.wordObj.words.length; i++) {
        const item = this.wordObj.words[i];
        if (item.title === '') {
          that.$message('请填写第'+(i+1)+'次的演讲主题！');
          return; // 直接退出函数
        }
        if (item.keyword === '') {
          that.$message('请填写第'+(i+1)+'次的每日一词！');
          return; // 直接退出函数
        }
        if (item.sort === '') {
          that.$message('请填写第'+(i+1)+'次的排序！');
          return; // 直接退出函数
        }
      }
      try {
        const response = await saveFixedLexicon(this.wordObj,this.token);
        if(response.code == 200){
          that.$message('成功');
          that.closeSub();
          that.getList();        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    beforeUploadVideo(file) {
      // this.loading = true;
      // this.loadTxt = '上传中...';
      // this.uploadObj.key = file.uid + file.name; // key为上传后文件名 必填


      const isVideo = file.type.startsWith('video/');
      if (!isVideo) {
        this.$message('只能上传视频文件！');
        return false;
      }
      
      const maxSize = 500 * 1024 * 1024;
      if (file.size > maxSize) {
        this.$message('视频大小不能超过 500MB！');
        return false;
      }
      
      if (!this.uploadObj.token) {
        this.$message('获取上传凭证失败，请刷新页面重试');
        this.getToken();
        return false;
      }
      
      this.loading = true;
      this.loadTxt = '上传中...';
      this.uploadObj.key = file.uid + '_' + file.name;
      
      return true;
    },

    beforeUploadImg(file) {
      this.loadingImg = true;
      this.loadTxt = '上传中...';
      this.uploadObj.key = file.uid + file.name; // key为上传后文件名 必填
    },

    handleSuccessImg(response, file, fileList) {
      this.addObj.images.push(response.key);
      this.loadingImg = false;
      this.uploadObj.key = "";
      this.loadTxt = '上传中...';
      this.$forceUpdate();
    },

    handleSuccessVideo(response, file, fileList,index) {
      // this.addObj.videos[index].video = response.key;
      // console.log(this.addObj.videos)
      // this.loading = false;
      // this.uploadObj.key = "";
      // this.loadingImg = false;
      // this.$forceUpdate();

      this.loading = false;
      this.uploadObj.key = "";
      
      if (response.code == 200 || response.key) {
        if (!this.addObj.videos) {
          this.addObj.videos = [];
        }
        if (!this.addObj.videos[index]) {
          this.addObj.videos[index] = { video: '', video_cont: '' };
        }
        
        this.addObj.videos[index].video = response.key;
        this.$message('上传成功');
        this.$forceUpdate();
      } else {
        this.$message(response.msg || '上传失败');
      }
    },

    handleProgressImg(event, file, fileList) {
      this.loadTxt = "已上传" + file.percentage.toFixed(0) + "%";
    },

    handleRemoveVideo(response, file, fileList,index) {
      this.addObj.image = "";
    },

    imgShow(){
      this.imgType = true;
    },

    imgHide(){
      this.imgType = false;
    },

    imgRemove(index){
      this.addObj.images.splice(index,1);
      this.$forceUpdate();
    },

    speechChange(){
      if(this.addObj.speech_type == 1){
        delete this.addObj.content;
        delete this.addObj.images;
        delete this.addObj.videos;
      } else {
        this.addObj.content = '';
        this.addObj.images = [];
        this.addObj.videos = [
          {video:'',video_cont:''}
        ];
      }
    },

    videoAdd(){
      this.addObj.videos.push({video:'',video_cont:''});
      this.$forceUpdate();
    },

    videoRemove(index){ 
      this.addObj.videos.splice(index,1);
      this.$forceUpdate();
    },
  }

  
};
</script>
<style scoped>
  .dataList .listItem p, 
  .organiza-list p{
    width: calc( 100% / 8 );
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .btn-remove,
  .btn-revise{
    background-image: url(~@/assets/images/btn-revise.png);
    width: 22px;
    height: 22px;
    background-size: 22px 22px;
    display: inline-block;
    vertical-align: top;
  }

  .btn-remove{
    background-image: url(~@/assets/images/btn-remove.png);
    margin-left: 50px;
  }

  .MobelBox{
    padding: 40px;
    box-sizing: border-box;
    width: 100%;
  }

  .MobelBox .write-txt{
    display: block;
    width: 100%;
    margin-bottom: 20px;
  }

  .MobelBox .write-title{
    font-size: 18px;
    color: #333333;
    display: inline-block;
    vertical-align: top;
  }

  .MobelBox .write-title span{
    color: #E2231A;
  }

  .MobelBox .write-text{
    display: inline-block;
    vertical-align: top;
    width: 80%;
    margin-left: 20px;
  }

  .MobelBox .write-text span{
    font-size: 14px;
    color: #E2231A;
    margin-top: 10px;
    display: block;
  }

  .MobelBox input,
  .MobelBox textarea{
    width: 80%;
    height: 65px;
    background-color: #F5F5F5;
    border-radius: 16px;
    display: block;
    padding: 10px;
    box-sizing: border-box;
  }
  
  .MobelBox input{
    height: 45px;
    width: 200px;
  }

  .write-btnBox{
    float: right;
    width: 100%;
    text-align: right;
  }

  .write-btnBox .btn{
    width: 120px;
    height: 56px;
    line-height: 56px;
    border-radius: 16px;
    color: #fff;
    background-color: #6E2FFF;
    padding: 0;
    margin: 0;
    font-size: 20px;
  }

  .write-btnBox .btn.btn-close{
    color: #999999;
    background-color: #F5F5F5;
    margin-left: 40px;
  }

  .msgBox .contv{
    padding: 40px 73px;
    border-radius: 32px;
  }

  .msgBox .title {
    text-align: center;
    margin-bottom: 50px;
  }

  .btn-import{
    display: inline-block;
    vertical-align: top;
  }

  .organiza-txt>>>.el-upload{
    width: 100%;
    display: block;
  }

  .organiza-txt>>>.el-button--small span{
    width: 100%;
    text-align: center;
    display: block;
  }

  .organiza-txt>>>.el-button--primary{
    background-color: transparent;
    border: none;
    font-size: 15px;
  }

  .btn-word-add{
    color: #6E2FFF;
    border: solid 1px #6E2FFF;
    border-radius: 8px;
    padding: 11px 34px;
    display: block;
    margin-top: 30px;
    font-size: 18px;
  }

  .btn-word-remove{
    background-color: #E2231A;
    border-radius: 8px;
    color: #fff;
    box-sizing: border-box;
    padding: 11px 52px;
    display: inline-block;
    vertical-align: middle;
    font-size: 18px;
  }

  .wordBox{
    height: calc( 100% - 100px );
  }

  .wordBox .word-item{
    margin-bottom: 20px;
    display: block;
    background-color: #fff;
    box-sizing: border-box;
    padding: 40px 30px;
  }

  .btn-video-remove,
  .btn-video-add{
    display: inline-block;
    vertical-align: top;
    width: 120px;
    height: 56px;
    border-radius: 16px;
    line-height: 56px;
    margin: 0 20px;
    background-color: #6E2FFF;
    font-size: 20px;
    color: #fff;
  }

  .btn-video-remove{
    background-color: #E2231A;
  }

  .write-text .img .hover{
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .6);
    position: absolute;
    top: 0;
    left: 0;
  }

  .write-text .img .icon-delete{
    background-image: url(~@/assets/images/btn-remove.png);
    width: 22px;
    height: 22px;
    background-size: 22px 22px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
  }
  
  .write-text>>> .el-radio-group{
    display: inline-block;
    vertical-align: top;
  }

  .write-txt>>> .el-radio__inner{
    width: 20px;
    height: 20px;
  }

  .write-txt>>> .el-radio__inner::after{
    width: 10px;
    height: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/word/index.vue